import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SvgIconModule } from '../../../svg-icon/svg-icon.module';
import { BankAccountRegisterSuccessComponent } from './bank-account-register-success.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [BankAccountRegisterSuccessComponent],
    declarations: [BankAccountRegisterSuccessComponent],
})
export class BankAccountRegisterSuccessModule { }
